import api from "../utils/axios-client";

const postLeagueGames = (leagueGamesInfo) => {
  return api.post(`operator/league-games`, leagueGamesInfo);
};

const getLeagueGames = (params) => {
  return api.get(`operator/league-games`, {
    params,
  });
};

const deleteLeagueGames = (id) => {
  return api.delete(`operator/league-games/${id}`);
};

const getDetailLeagueGames = (id) => {
  return api.get(`operator/league-games/${id}`);
};

const editLeagueGame = (id, data) => {
  return api.patch(`operator/league-games/${id}`, data);
};

export const LeagueGamesAPI = {
  postLeagueGames,
  getLeagueGames,
  deleteLeagueGames,
  getDetailLeagueGames,
  editLeagueGame,
};
